

export class DateWiseTokenConsumptionModel {
    date: string;
    consumedTokens: number;

    /**
     * 
     * @param date 
     * @param consumedTokens 
     */
    constructor(date: string, consumedTokens: number) {
        this.date = date;
        this.consumedTokens = consumedTokens;
    }
}